// Projector (Entertainment) : les formats et leur escalier de preuves, les tests,
// les soirées et le registre, les diffuseurs, les pays de l'export, le weekly,
// les livrables imprimables ; et le programme 90 jours d'une marque.
//
// Les tables `etape`, `etat` et `groupe` recopient celles de l'API
// (`packages/domain/src/entertainment.ts` : ETAPE_ENT, LIBELLE_ETAT_ENT,
// LIBELLE_GROUPE_ENT), lues ici par leur clé.
export default {
  citation: '« {texte} »',
  fourchette: '{bas} % ~ {haut} %',
  cible: {
    '4+': '4 ans et plus',
    '4-14': '4-14 ans',
    '15-34': '15-34 ans',
    '25-49': '25-49 ans',
    'FRDA-50': 'FRDA-50',
    '50+': '50 ans et plus',
  },
  // Les tranches d'âge d'une étude (15 octobre 2026).
  tranche: {
    de: '{lo}-{hi} ans',
    etPlus: '{lo} ans et plus',
    ans: '{n} ans',
    aucune: 'Aucune tranche : l’étude prend tous les âges de ses publics.',
    ajouter: 'Ajouter une tranche d’âge',
    retirer: 'Retirer {tranche}',
    min: 'Âge minimum, tranche {n}',
    max: 'Âge maximum, tranche {n}',
    max4: '{max} tranches au plus.',
  },
  dimensionPublic: {
    pyramide: 'les âges',
    femmes: 'la part de femmes',
    diplome: 'les diplômes',
    urbanite: 'le lieu de vie',
    origine: 'l’origine',
    religion: 'la religion',
  },
  etat: {
    preparation: 'Protocole en rédaction',
    protocole_en_echec: 'Protocole en échec',
    a_relire: 'À relire avant de lancer',
    lancement: 'La population se fige',
    en_cours: 'Le panel répond',
    rendu: 'Résultat rendu',
    partiel: 'Résultat partiel',
    echec: 'Test en échec',
  },
  etape: {
    brief: {
      titre: 'Brief',
      support: 'la catégorie, le diffuseur, la case, la cible, l’objectif d’audience',
      stimulus: 'les paramètres : chaîne, case, concurrence',
      sortie: 'les publics à interroger pour ce diffuseur',
    },
    format_papier: {
      titre: 'Format papier',
      support: 'le titre, la logline, la promesse',
      stimulus: 'un texte court',
      sortie: 'l’envie de regarder par cible, et les indifférents',
    },
    dossier: {
      titre: 'Dossier',
      support: 'la note d’intention, la mécanique, le ton',
      stimulus: 'un texte long, en variantes',
      sortie: 'la variante qui gagne, cible par cible',
    },
    visuel: {
      titre: 'Visuel',
      support: 'le deck, le moodboard, le décor, les teasers',
      stimulus: 'des images, des vidéos',
      sortie: 'l’adhésion à l’univers',
    },
    casting: {
      titre: 'Casting',
      support: 'l’animateur, les coachs, les candidats',
      stimulus: 'des noms, des photos',
      sortie: 'l’effet talent par cible',
    },
    ab: {
      titre: 'A/B Testing',
      support: 'les variantes, les visuels, les talents',
      stimulus: 'des textes, des images, des vidéos, des noms',
      sortie: 'la version qui l’emporte, cible par cible',
    },
    pilote: {
      titre: 'Épisode',
      support: 'un épisode, le pilote, la démo',
      stimulus: 'une vidéo',
      sortie: 'la rétention séquence par séquence, les moments forts et les creux, le ressenti',
    },
    lancement: {
      titre: 'Diffusion',
      support: 'la grille concurrente, ou la sortie sur une plateforme',
      stimulus: 'une soirée simulée',
      sortie: 'la part d’audience projetée, puis confrontée à la mesure',
    },
    export: {
      titre: 'Export',
      support: 'le format, pays par pays',
      stimulus: 'le même format, lu ailleurs',
      sortie: 'la stabilité d’un pays à l’autre',
    },
  },
  groupe: {
    programme: 'Le public du programme',
    france: 'La France',
    ville: 'Les métropoles',
    chaine: 'Les publics des chaînes',
    plateforme: 'Les publics des plateformes',
    jeunes: 'Les publics jeunes',
    pays: 'Les pays de l’export',
    thematique: 'Les publics thématiques',
    politique: 'Les publics politiques',
  },
  provenance: {
    mesure: 'Mesure',
    simulation: 'Simulation',
    observation: 'Veille',
  },
  profil: {
    femme: 'femme',
    homme: 'homme',
    age: '{age} ans',
  },
  erreur: {
    grilles: 'Grilles illisibles',
  },
  commun: {
    chargement: 'Chargement…',
    fermer: 'Fermer',
    fermerMin: 'fermer',
    retirer: 'Retirer',
    annuler: 'Annuler',
    refuse: 'Refusé',
    valider: 'Valider',
    rejeter: 'Rejeter',
    ecarter: 'Écarter',
    enregistrer: 'Enregistrer',
    archiver: 'Archiver',
    cible: 'Cible',
    leRegarderaient: 'Le regarderaient',
    scenarios: 'Scénarios',
    ensemble: 'Ensemble',
    vosCibles: 'Vos cibles',
    pays: 'Pays',
    audienceAuLancement: 'Audience au lancement',
    sur: 'sur {sur}',
    entre: ', entre {a} et {b}',
    devant: ', devant {a}',
    derriere: ', derrière {a}',
    scenariosCourts: '{bas} ~ {haut}',
    format: 'Format',
    chaineAnnee: 'Chaîne, année',
    simulee: 'Simulée',
    projetee: 'Projetée',
    partDAudience: 'Part d’audience',
    mesuree: 'Mesurée',
    ecart: 'Écart',
    telespectateurs: 'Téléspectateurs',
    millionsScenarios: '{valeur}{bornes}',
    ceQueLePanelEnDit: 'Ce que le panel en dit',
    aValider: '{nb} à valider',
    programme: 'Programme',
    reelle: 'Réelle',
    placeholderPda: 'PdA %',
    placeholderTelespectateurs: 'téléspectateurs',
    releveEnCours: 'Relevé en cours',
    raisonInconnue: 'raison inconnue',
    chaine: 'Chaîne',
    genre: 'Genre',
    source: 'Source',
    valideMin: 'validé',
    quiLaRegarde: 'Qui la regarde',
    ceDontSonPublicParle: 'Ce dont son public parle',
    formatsTestesPourElle: 'Les formats testés pour elle',
  },
  panel: {
    titre: 'Le panel interrogé',
    bloc: {
      age: 'Âge',
      genre: 'Sexe',
      csp: 'CSP',
      diplome: 'Diplôme',
      foyer: 'Foyer',
      lieu: 'Lieu de vie',
      publics: 'Publics',
    },
  },
  ecoute: {
    enLigne: 'En ligne',
    ecouter: 'Écouter en ligne',
    pasEncore: 'Pas encore écouté.',
    enCours: 'Écoute en cours.',
    polarite: '{favorable} favorables, {neutre} neutres, {defavorable} défavorables',
    favorables: 'favorables',
    neutres: 'neutres',
    defavorables: 'défavorables',
    voirPlus: 'Voir plus',
    rien: 'Rien de lisible en ligne pour l’instant.',
    reecouter: 'Réécouter',
    panneau: 'Ce que « {titre} » provoque en ligne',
    origine: 'les gens qui parlent de « {titre} » en ligne',
  },
  corpus: {
    erreur: {
      illisibles: 'Documents illisibles',
      depot: 'Dépôt refusé',
    },
    titreParDefaut: 'Note',
    cetteComposition: 'cette composition',
    avisPublic: 'Le public du programme est désormais tiré sur {dimension} de ce chiffre ; pour tout le reste, c’est la France.',
    sur: 'sur {max}',
    titre: 'Les documents du format',
    natureDuDocument: 'Nature du document',
    nature: {
      brief: 'Brief, cahier des charges',
      presentation: 'Présentation, deck',
      bible: 'Bible, concept du format',
      script: 'Script, conducteur, séquencier',
      etude: 'Étude',
      sondage: 'Sondage',
      donnees: 'Données, audiences',
      presse: 'Presse, revue de presse',
      veille: 'Veille, concurrence',
      compte_rendu: 'Compte rendu de réunion',
      contrat: 'Contrat, appel d’offres',
      note: 'Note',
      media: 'Visuel',
    },
    deposerFichiers: 'Déposer des fichiers',
    collerTexte: 'Coller un texte',
    sonTitre: 'Son titre',
    placeholderTexte: 'Ce que vous savez de ce format et de son public : une note, un extrait d’étude, des audiences…',
    ajouter: 'Ajouter au corpus',
    envoi: 'Envoi en cours…',
    toutLeCompte: 'tout le compte',
    chiffres: '{n} chiffre | {n} chiffre | {n} chiffres',
    enLecture: 'En lecture',
    illisible: 'Illisible',
    lu: 'Lu',
    misDeCote: 'Mis de côté',
    mettreDeCote: 'Mettre de côté',
    resservir: 'S’en servir à nouveau',
    retirer: 'Retirer du corpus',
    chiffresLus: 'Les chiffres lus',
    compositionDuPublic: 'Composition du public : {dimension}',
    valide: 'Validé',
    rejete: 'Rejeté',
    tirerDessus: 'Le chiffre est juste, tirez dessus',
    aucun: 'Aucun document encore.',
  },
  creation: {
    variante: 'Variante {lettre}',
    visuel: 'Visuel {n}',
    pilote: 'Épisode de « {titre} »',
    erreur: {
      envoi: 'Envoi impossible',
      test: 'Test refusé',
    },
    probleme: {
      public: 'Choisissez au moins un public.',
      comparable: 'Chaque comparable a un nom et quelques lignes de description.',
      variante: 'Chaque variante est un texte d’au moins quelques lignes.',
      visuel: 'Chaque visuel a son image ou sa vidéo.',
      talent: 'Chaque talent a un nom.',
      video: 'Déposez la vidéo ou donnez son lien YouTube.',
      grille: 'Relevez d’abord la grille de la soirée.',
      programme: 'Choisissez le programme.',
      dateSortie: 'Renseignez la date de sortie dans le brief (première diffusion).',
      pays: 'Choisissez au moins un pays.',
    },
    tester: 'Tester : {etape}',
    ceQueLePanelVerra: 'Ce que le panel verra',
    promesse: 'La promesse : {texte}',
    placeholder: {
      comparable: 'Nom du comparable (pour vous seul)',
      pdaReelle: 'PdA réelle %',
      description: 'Sa description, sans son titre : le panel le lit à l’aveugle',
      noteIntention: 'La note d’intention, la mécanique, le ton de cette version',
      talent: 'Nom du talent (animateur, coach, candidat)',
      visuel: 'Nom du visuel',
      role: 'Ce qu’il ferait dans le programme (facultatif)',
      legende: 'Une légende, si le visuel en a une (facultatif)',
      adresse: 'ou son adresse https://',
      youtube: 'ou un lien YouTube https://',
    },
    ajouterComparable: 'Ajouter un comparable',
    ajouterVariante: 'Ajouter une variante',
    deposerPhoto: 'Déposer une photo',
    deposerImage: 'Déposer l’image',
    ajouterTalent: 'Ajouter un talent',
    ajouterVisuel: 'Ajouter un visuel',
    deposerVideo: 'Déposer la vidéo',
    sortie: '« {titre} » sort sur {plateforme} le {jour}.',
    sortieSansDate: '« {titre} » sort sur {plateforme}.',
    sortieMesure: 'qui le regarderait dans sa première semaine, cible par cible',
    ab: {
      compare: 'Ce qu’on compare',
      dossier: 'Des textes',
      visuel: 'Des visuels ou des vidéos',
      casting: 'Des talents',
      mode: 'Comment le panel les voit',
      separe: 'Séparément',
      separeAide: 'Chaque jumeau voit une seule version et dit son envie ; l’écart se lit d’une version à l’autre. C’est le plus proche de la vraie vie.',
      coteACote: 'Côte à côte',
      coteACoteAide: 'Chaque jumeau voit toutes les versions, puis choisit celle qui lui donne le plus envie, ou aucune. Plus sensible aux petits écarts, qu’il grossit aussi.',
      deuxAuMoins: 'Côte à côte, il faut deux versions au moins.',
    },
    sortieQuestion: 'Les jumeaux disent s’ils le regarderaient, et quand : dès sa sortie, dans la semaine, plus tard ou pas du tout.',
    aucuneGrille: 'Aucune grille relevée.',
    // Les soirées de la grille, sans relevé (19 octobre 2026).
    grilleVide: 'La grille ne couvre pas encore les jours à venir : elle se relit chaque nuit.',
    soireesAVenir: 'La grille, les jours à venir',
    soireesRelevees: 'Les soirées déjà relevées',
    soireesPassees: 'Les soirées passées, rejouées à l’aveugle',
    // Ce que l'on sait d'avance d'une soirée (19 octobre 2026).
    contexte: {
      annonce: 'Ce que le programme annonce ce soir-là',
      annoncePlaceholder: 'Par exemple : ce samedi, pas d’élimination ; des invités surprises.',
      case: 'Ajouter ce qui s’est dit en ligne du programme la semaine d’avant',
      calcul: 'Lecture des réseaux de la semaine d’avant…',
      erreur: 'Ce qui s’est dit en ligne n’a pas pu se lire : le test se prépare sans.',
      apercu: 'Ce que le panel lira du programme, en plus du programme télé :',
      rien: 'Rien de marquant en ligne la semaine d’avant : le programme se présente sans.',
      partiel: 'Les réseaux ne gardent que sept jours : une partie de la semaine d’avant n’a pas pu se compter.',
      attente: 'Ce qui s’est dit en ligne se lit encore.',
    },
    releverGrille: 'Relever la grille d’une soirée',
    nProgrammes: '{nb} programmes',
    programmeProjete: 'Le programme dont on projette l’audience :',
    quiRepond: 'Qui répond',
    jusquA: 'Jusqu’à {max} publics',
    combienDeJumeaux: 'Combien de jumeaux par version',
    jumeauxParPublic: 'Combien de jumeaux par public',
    totalVersion: '{publics} public × {par} = {total} jumeaux par version | {publics} public × {par} = {total} jumeaux par version | {publics} publics × {par} = {total} jumeaux par version',
    plafond: ' (plafond d’une version)',
    cibles: {
      titre: 'La cible',
      aide: 'Les jumeaux se tirent dans ces cibles, et le test se lit sur elles.',
      aucune: 'Aucune cible : le test se lit sur tout le panel.',
    },
    publics: 'Les publics',
    // La fenêtre de création, une étape à la fois (15 octobre 2026).
    pas: {
      etapes: 'Les étapes',
      montre: 'Ce qu’on montre',
      soiree: 'La soirée',
      appuis: 'S’appuyer sur',
      publics: 'Qui répond',
      ages: 'Les âges',
      n: 'Étape {n} sur {total}',
      suivant: 'Suivant',
      precedent: 'Précédent',
    },
    ages: {
      titre: 'Les âges (facultatif)',
      aide: 'Les jumeaux se tirent dans ces âges, et l’étude se lit tranche par tranche.',
      frda: 'Femmes responsables des achats de moins de 50 ans',
      orphelines: '{ages} : aucun public choisi n’a ces âges.',
      couvrir: 'Ajouter les publics de ces âges',
    },
    appuis: {
      titre: 'S’appuyer sur',
      aideSortie: 'Les jumeaux voient le programme tel que ces études l’ont fait gagner : le pitch testé, la version retenue. Le résultat les enchaîne.',
      aideSoiree: 'Le programme se présente dans le guide de la soirée tel que ces études l’ont fait gagner : la version retenue, le talent, le visuel. Le résultat les enchaîne.',
      aucune: 'Aucune',
      vide: 'Aucune étude rendue',
      bloc: {
        format_papier: 'Format papier',
        ab: 'A/B Testing',
        pilote: 'Épisode',
      },
      envie: '{pct} en ont envie',
      version: 'La version retenue',
      gagnante: 'gagnante',
      jusquAuBout: '{pct} vont jusqu’au bout',
      chargement: 'Lecture…',
      ajouter: 'Ajouter',
      changer: 'Changer',
      retirer: 'Retirer',
      aucuneChoisie: 'Aucune étude choisie',
      choisir: 'Choisir une étude : {bloc}',
      lEmporte: '« {version} » l’emporte, {pct}',
    },
    nJumeaux: '{nb} jumeaux',
    preparer: 'Préparer le test',
  },
  // Ce qu'une soirée simulée a donné au panel (20 octobre 2026).
  donne: {
    titre: 'Ce que le panel a reçu',
    backtest: 'rejouée à l’aveugle',
    annonce: 'Annonce : « {texte} »',
    enLigne: 'Ce qui s’est dit en ligne la semaine d’avant',
    seul: 'Le programme télé seul, sans annonce ni contexte',
    habitudes: 'Habitudes de chaîne tirées des parts d’audience',
    appui: { format_papier: 'Le format papier', ab: 'L’A/B Testing', pilote: 'L’épisode' },
  },
  test: {
    pilote: {
      debut: 'Début',
      fin: 'Fin',
      titre: 'Qui regarde encore',
      tenue: 'La tenue d’une région à l’autre : jusqu’au bout',
      jusquAuBout: '{cible} : {pct} jusqu’au bout',
    },
    erreur: {
      illisible: 'Test illisible',
      action: 'Action refusée',
    },
    export: {
      verdict: {
        stable: 'stable : il voyage tel quel',
        variable: 'variable : il s’adapte',
        fragile: 'fragile : il se refait',
        illisible: 'illisible',
      },
      avecEcart: 'Le format est {verdict} (écart maximal à la France : {ecart} points).',
      sansEcart: 'Le format est {verdict}.',
    },
    etape: {
      format_papier: 'Format papier',
      dossier: 'Dossier',
      visuel: 'Visuel',
      casting: 'Casting',
      pilote: 'Épisode',
      lancement: 'Soirée simulée',
      export: 'Export',
      etalonnage: 'Étalonnage d’un pays',
    },
    grilleDeLaSoiree: 'La grille de la soirée',
    versions: '{n} version | {n} version | {n} versions',
    jumeauxChacune: '{nb} jumeaux chacune',
    panelFige: 'Panel figé au {jour}',
    aLAveugle: ', à l’aveugle',
    reference: 'référence',
    ceQueLePanelVoit: 'Ce que le panel voit, version par version',
    tirEnEchec: 'Tir en échec',
    protocoleSEcrit: 'Le protocole s’écrit.',
    protocoleEchoue: 'La rédaction du protocole a échoué.',
    reecrireProtocole: 'Réécrire le protocole',
    ceQueLePanelLira: 'Ce que le panel lira',
    termesFiges: 'Les termes figés',
    definition: '{terme} : {sens}',
    soireePassee: 'Cette soirée est passée : elle se rejoue en backtest à l’aveugle.',
    taille: '{bras} × {effectif} jumeaux',
    environ: 'environ {duree}',
    dureeMinutes: '{n} minutes',
    dureeHeures: '{h} h {m}',
    dureeHeuresRondes: '{h} h',
    lancerBacktest: 'Lancer le backtest',
    lancerTest: 'Lancer le test',
    lePanelPart: 'Le panel part.',
    lePanelRepond: 'Le panel répond · environ {duree} en tout.',
    lePanelRepondReste: 'Le panel répond · encore environ {duree}.',
    reponsesRecues: '{pct} des réponses reçues',
    versionSansReponse: 'Une version n’a pas répondu.',
    relancer: 'Relancer',
    redresse: 'Redressé sur la France de 4 ans et plus :',
    redressement: '{bande} {panel} du panel, {france} de la France ;',
    envieDeRegarder: 'L’envie de regarder',
    leRegarderaientFourchette: 'le regarderaient ({fourchette})',
    surVosCibles: 'sur vos cibles : {cibles}',
    indifferentsEgal: 'd’indifférents (« ça m’est égal »)',
    indifferents: 'Indifférents',
    reponses: 'Réponses',
    dansSaClasse: 'Dans sa classe',
    surLusAveugle: 'sur {sur}, lus à l’aveugle par le même panel',
    leFormat: 'Le format',
    pdaReelle: 'PdA réelle {pda}',
    projectionParLaClasse: 'Projection par la classe : {pda} de part d’audience{bornes}, sur {points} comparables dont l’audience est connue.',
    comparaison: {
      casting: 'L’effet de chaque talent',
      export: 'Le format, d’un pays à l’autre',
      visuel: 'L’adhésion à chaque univers',
      dossier: 'La variante qui gagne',
    },
    lEmporte: '{nom} l’emporte.',
    devanceDePeu: '{nom} devance de peu : moins de cinq points.',
    passeport: {
      titre: 'Le passeport : le format lu dans chaque pays, parmi ses propres formats',
      parmiLesFormats: 'Parmi les formats du pays',
      etalonner: 'Étalonner {pays}',
    },
    etalons: {
      titre: 'Les formats étalons, lus par la population du pays',
    },
    // La 2e partie du prime (20 octobre 2026).
    seconde: {
      titre: 'La 2e partie, {creneau}',
    },
    soiree: {
      titreSimulee: 'La part d’audience simulée · {programme}',
      titreProjetee: 'La part d’audience projetée · {programme}',
      panelBrut: 'Panel brut',
      dOuVient: 'D’où vient le chiffre',
      mesures: 'mesurés : {valeur}',
      nosJumeaux: 'nos jumeaux, à 100 %',
      habitude: 'l’habitude mesurée, à 100 %',
      etLeGenre: ', et le genre',
      melange: 'jumeaux {isos} %, habitude {mesure} %',
      corrigee: 'Corrigée par la calibration v{version}, apprise des soirées déjà confrontées au réel : « d’où vient le chiffre » dit ce qu’elle prend aux jumeaux et ce qu’elle prend à l’habitude de la chaîne.',
      essaiDu: 'Essai du {moment}',
      projectionDu: 'Projection du {moment}',
      enregistrerEssai: 'Enregistrer un essai',
      enregistrerBacktest: 'Enregistrer le backtest',
      enregistrerProjection: 'Enregistrer la projection',
      enDirect: 'La soirée en direct · ensemble',
      ouVaLaSoiree: 'Où va la soirée · tous écrans',
    },
    ecran: {
      direct: 'Télévision en direct',
      replay: 'Replay, à la demande',
      plateforme: 'Plateformes',
      reseaux: 'YouTube, réseaux',
      aucun: 'Aucun écran',
    },
    personas: {
      titre: 'Les personas du panel',
      origine: 'le panel de ce test',
      q1: 'Pourquoi tu le regarderais ?',
      q2: 'Qu’est-ce qui te retient ?',
      q3: 'Quelle version t’a le plus parlé, et pourquoi ?',
    },
  },
  livrable: {
    titre: {
      dossier: 'Dossier d’audience',
      casting: 'Note de casting',
      passeport: 'Passeport de format',
      diffuseur: 'Carte du diffuseur',
      enveloppe: 'La projection',
      sonar: 'Note d’étude',
    },
    livrable: 'Livrable',
    illisible: 'Livrable illisible',
    retour: 'Retour',
    imprimer: 'Imprimer',
    confidentiel: 'Confidentiel',
    dossier: {
      envie: '{pct} du panel le regarderait{fourchette} ; {indifferents} y sont indifférents.',
      classe: 'Dans sa classe : {rang} formats comparables lus à l’aveugle.',
      classeAvecProjection: 'Dans sa classe : {rang} formats comparables lus à l’aveugle ; projection par la classe : {pda} de part d’audience{bornes}.',
      adhesion: 'L’adhésion à l’univers',
      versionQuiGagne: 'La version qui gagne',
      devanceDePeu: '{nom} devance de peu.',
    },
    nomCitation: '{nom} : « {texte} »',
    casting: {
      explication: 'Chaque talent se lit contre le même programme sans talent annoncé : l’écart est son effet.',
      talent: 'Talent',
    },
    passeport: {
      stabilite: 'La stabilité d’un pays à l’autre',
      ecartFrance: 'Écart à la France',
      parmiSesFormats: 'Dans chaque pays, parmi ses propres formats',
      place: 'Place parmi les formats du pays',
    },
    scenarios: '({bas} ~ {haut})',
    diffuseur: {
      public: 'Public',
      part: 'Part',
      ages: 'Âges',
      pda: 'Sa part d’audience (Médiamat, 4 ans et plus)',
      observation: 'Observation · conversations publiques',
      ceQuiMonte: 'Ce qui monte :',
    },
    enveloppe: {
      enregistreeLe: '{quoi}, enregistrée le {moment}',
      partProjetee: 'Part d’audience projetée',
      audiencePubliee: 'Audience publiée',
      aVenir: 'à venir',
      note: 'Part d’audience parmi ceux qui regardent la télévision en direct{calibration}. Grille de la soirée : {grille}.',
      calibrationV: ', calibration v{version}',
      empreinte: 'Empreinte SHA-256 du contenu canonique de l’enveloppe :',
      temoins: 'Soumise aux témoins OpenTimestamps : {liste}. La preuve (.ots) se vérifie sans Orion, contre l’empreinte, une fois ancrée dans Bitcoin.',
      aucun: 'aucun',
    },
    pied: {
      test: 'Panel de jumeaux construits sur les statistiques publiques de chaque population (âge, genre, diplôme, sensibilité), interrogés {quand}{population}.',
      leMoment: 'le {moment}',
      populationFigee: ' sur une population figée au {jour} (empreinte {empreinte})',
      sonar: 'Panel de jumeaux construits sur les statistiques publiques de chaque population (âge, genre, diplôme, sensibilité), interrogés le {jour}.',
      defaut: 'Orion · simulation d’audience. Les chiffres publiés viennent de leurs sources.',
    },
  },
  formats: {
    erreur: {
      formats: 'Formats illisibles',
      format: 'Format illisible',
      titre: 'Donnez un titre au format.',
      refuse: 'Format refusé',
      archivage: 'Archivage refusé',
      visuel: 'Le visuel n’a pas pu être déposé.',
      visuelLourd: 'L’image dépasse 12 Mo.',
      populations: 'Populations illisibles',
    },
    laComposition: 'la composition',
    etListe: '{debut} et {fin}',
    boucle: 'bouclé',
    feuilletonnantMin: 'feuilletonnant',
    episodes: '{nb} épisodes',
    adapteDe: 'adapté de : {pays}',
    premiereLe: 'première diffusion le {jour}',
    sousTitre: 'La simulation d’audience pour la télévision, le cinéma et les plateformes : l’escalier de preuves d’un format',
    leBrief: 'Le brief du format',
    creePar: 'Créé par {nom}',
    unNouveau: 'Un nouveau format',
    champ: {
      titre: 'Titre',
      titrePlaceholder: 'Même provisoire',
      logline: 'Logline : le programme en une ou deux phrases',
      promesse: 'La promesse au téléspectateur',
      genre: 'Genre',
      genrePlaceholder: 'divertissement, jeu, fiction, docu…',
      diffuseur: 'Diffuseur visé',
      sansDestination: 'Pas encore de destination',
      case: 'Case',
      casePlaceholder: 'le samedi en prime time',
      cibles: 'Cibles',
      ecriture: 'Écriture',
      nonDecidee: 'Non décidée',
      bouclee: 'Bouclée',
      feuilletonnante: 'Feuilletonnante',
      episodes: 'Épisodes',
      objectif: 'Objectif d’audience',
      objectifPlaceholder: 'tenir 20 % sur les 4 ans et plus',
      premiere: 'Première diffusion',
      paysOrigine: 'Format étranger : pays d’origine',
      visuel: 'Le visuel du format',
      visuelAjouter: 'Ajouter une image',
      visuelRemplacer: 'Remplacer l’image',
      visuelRetirer: 'Retirer',
    },
    enregistrerBrief: 'Enregistrer le brief',
    creer: 'Créer le format',
    brief: 'Le brief',
    laPromesse: 'La promesse :',
    lObjectif: 'L’objectif :',
    publicDuProgramme: 'Le public du programme',
    publicPeutInterroger: 'Les tests de ce format peuvent interroger {nom} ({dimensions}).',
    escalier: 'L’escalier de preuves',
    panelConseille: 'Panel conseillé : {noms}',
    tester: 'Tester',
    unePreuve: 'Une preuve, avant de tourner',
    deposer: 'Déposer un format',
    soireesEtRegistre: 'Les soirées et le registre',
  },
  soirees: {
    titre: 'Soirées & registre',
    sousTitre: 'La soirée simulée, projetée avant diffusion, puis confrontée à l’audience publiée',
    erreur: {
      registre: 'Registre illisible',
      grille: 'Grille illisible',
      soiree: 'Soirée refusée',
      grilleRefusee: 'Grille refusée',
      releve: 'Relevé refusé',
      projection: 'Projection refusée',
      enveloppe: 'Enveloppe illisible',
      saisie: 'Saisie refusée',
      preuve: 'Preuve indisponible',
      calibration: 'Calibration illisible',
    },
    statutGrille: {
      en_cours: 'relevé en cours',
      propose: 'à relire',
      valide: 'validée',
      echec: 'relevé en échec',
    },
    essai: 'Essai',
    backtestAveugle: 'Backtest à l’aveugle',
    projection: 'Projection',
    diffusionLe: 'Diffusion le {jour}',
    projeteeLe: 'projetée le {moment}',
    leRegistre: 'Le registre',
    enveloppeAImprimer: 'L’enveloppe à imprimer',
    soireeSimulee: 'La soirée simulée',
    projeteEtEuLieu: 'Ce qui a été projeté, et ce qui a eu lieu',
    calibrationAppliquee: 'Calibration v{version} appliquée à la projection.',
    preuve: {
      titre: 'La preuve',
      empreinte: 'Empreinte SHA-256 du contenu canonique :',
      recalculee: 'Recalculée à l’instant : le contenu n’a pas bougé.',
      neCorrespondPlus: 'L’empreinte ne correspond plus au contenu.',
      temoins: 'Les témoins (OpenTimestamps, ancrés ensuite dans Bitcoin) :',
      telecharger: 'Télécharger la preuve .ots',
      telechargerContenu: 'Télécharger le contenu scellé .json',
      retirerPublic: 'Retirer du registre public',
      rendrePublique: 'Rendre publique',
    },
    audiencePubliee: 'L’audience publiée',
    relever: 'Relever',
    pasEncoreDiffusee: 'La diffusion n’a pas encore eu lieu.',
    placeholderSource: 'source',
    saisir: 'Saisir',
    onglet: {
      registre: 'Le registre',
      soirees: 'Les soirées',
      calibration: 'La calibration',
    },
    registre: {
      enregistrees: 'projections enregistrées',
      confrontees: 'projections avant diffusion confrontées au réel',
      pts: '{v} pts',
      erreurMoyenne: 'd’erreur moyenne (4 ans et plus)',
      erreurBrute: ', {v} pts brute',
      dansLaFourchette: 'dans la fourchette projetée',
      tableau: 'Le tableau des scores',
      calibrationActive: 'Calibration active : v{version}',
      aucune: 'Aucune enveloppe encore.',
      diffusion: 'Diffusion',
      projetee4: 'Projetée (4+)',
      temoins: 'Témoins',
      essai: 'essai',
      backtest: 'backtest',
    },
    uneSoiree: 'Une soirée',
    releverGrilleEtPublic: 'Relever la grille et le public de référence',
    releverSoiree: 'Relever la soirée',
    saisirGrille: 'Saisir la grille',
    relevezUneGrille: 'Relevez la grille d’une soirée.',
    laGrilleSeReleve: 'La grille se relève.',
    projeterAudience: 'Projeter son audience',
    ajouterChaine: 'Ajouter une chaîne',
    publicDeReference: 'Le public de référence : les téléspectateurs devant la télévision sur ce créneau',
    sources: 'Sources',
    validerGrille: 'Valider la grille',
    audiencesDeLaSoiree: 'Les audiences de la soirée',
    validerLignes: 'Valider les {nb} lignes sourcées',
    releverAudiences: 'Relever les audiences de la soirée',
    releveEchoue: 'Le relevé a échoué : {raison}',
    calibration: {
      titre: 'Une couche séparée, versionnée, qui n’apprend que du passé',
      texte1: 'Les jumeaux ne voient jamais le résultat visé. La calibration corrige la lecture, pas le panel : cible par cible, elle apprend de chaque programme des soirées déjà confrontées à leur audience publiée, ce que le panel en a lu et ce que sa chaîne fait d’habitude.',
      texte2: 'Son effet se mesure en validation croisée (chaque soirée corrigée par ce qui a été appris sans elle), et une version ne s’applique qu’une fois activée à la main.',
      confrontes: '{programmes} programmes confrontés, sur {soirees} soirée | {programmes} programmes confrontés, sur {soirees} soirée | {programmes} programmes confrontés, sur {soirees} soirées',
      erreur: 'erreur {avant} pts brute → {apres} pts corrigée',
      apprendre: 'Apprendre une nouvelle version',
      commeReference: 'Référence du moteur, pour les comptes sans calibration',
      reference: 'référence du moteur',
      famille: { habitudes: 'soirées avec habitudes de chaîne', sans_habitudes: 'soirées sans habitudes de chaîne' },
      parProgramme: 'Programme par programme',
      soiree: 'Soirée',
      panel: 'Panel',
      habitude: 'Habitude de la chaîne',
      corrige: 'Corrigé',
      reel: 'Réel',
      version: 'Version {version}',
      activeDepuis: 'active depuis le {moment}',
      appriseSurProgrammes: 'apprise sur {programmes} programmes de {soirees} soirée le {moment} | apprise sur {programmes} programmes de {soirees} soirée le {moment} | apprise sur {programmes} programmes de {soirees} soirées le {moment}',
      appriseSur: 'apprise sur {soirees} soirée le {moment} | apprise sur {soirees} soirée le {moment} | apprise sur {soirees} soirées le {moment}',
      erreurVersion: 'erreur {avant} → {apres} pts',
      activer: 'Activer',
      decalage: '{cible} : {points} à 20 % ({nb})',
      modele: '{cible} : {description} ({nb} programmes)',
      exemple: '{cible} : un programme lu à 20 % se corrige à {grande} sur une grande chaîne, {petite} sur une petite{genre} ({nb} programmes)',
      puisSelonGenre: ', puis selon son genre',
      corrigeeDuGenre: ', corrigée du genre du programme',
      partHabituelle: 'la part habituelle de la chaîne{genre}',
      partDeLHabitude: 'part de l’habitude de la chaîne, le panel la déplace{genre}',
      lectureRamenee: 'la lecture du panel, ramenée à toute la télévision{genre}',
      aucuneVersion: 'Aucune version encore.',
    },
  },
  diffuseurs: {
    titre: 'Diffuseurs',
    sousTitre: 'Qui regarde chaque chaîne et chaque plateforme, comment sa part d’audience bouge, ce dont son public parle',
    erreur: {
      sorties: 'Sorties illisibles',
      createurs: 'Créateurs illisibles',
      tendances: 'Tendances illisibles',
      soirees: 'Soirées illisibles',
      programme: 'Programme illisible',
      carte: 'Carte illisible',
      diffuseurs: 'Diffuseurs illisibles',
      recherche: 'Recherche impossible',
    },
    onglet: {
      ensemble: 'Vue d’ensemble',
      programme: 'Le programme',
      soirees: 'Les soirées',
      sorties: 'Les sorties',
      tendances: 'Ce qui trend',
      createurs: 'Les créateurs qui montent',
    },
    saisonEpisode: 'saison {saison}, épisode {episode}',
    saison: 'saison {saison}',
    points: '{v} pt',
    netflix: {
      series: 'Les séries les plus vues',
      films: 'Les films les plus vus',
      horsAnglais: 'Les plus vus hors langue anglaise',
      titre: 'Ce que le monde a regardé sur Netflix · {periode}',
      rapport: 'Le rapport de Netflix',
      placeholder: 'Un titre, dans tous les rapports depuis 2023 : Lupin, Love Is Blind, Squid Game…',
      chercher: 'Chercher',
      periodeCol: 'Période',
      titreCol: 'Titre',
      rang: 'Rang',
      vuesCol: 'Vues',
      heures: 'Heures',
      sortie: 'Sortie',
      serie: 'série',
      film: 'film',
      aucun: 'Aucun titre de ce nom dans les rapports.',
    },
    periode: '{debut} à {fin}',
    semestre1: '1er sem. {annee}',
    semestre2: '2e sem. {annee}',
    lesChaines: 'Les chaînes',
    lesPlateformes: 'Les plateformes',
    plateforme: 'Plateforme',
    chaine: 'Chaîne',
    pdaEn: '{pda} de part d’audience en {mois}',
    ecartSur: '{ecart} sur {mois}',
    tous: 'Tous les diffuseurs',
    carteAImprimer: 'La carte à imprimer',
    laVeille: 'La veille',
    leLendemain: 'Le lendemain',
    aucunProgramme: 'Aucun programme relevé ce jour-là.',
    archive: 'Le programme de {nom} est archivé du {debut} au {fin}.',
    soiree: 'Soirée',
    premierePartie: '1re partie de soirée',
    moyenne: '{pda} en moyenne sur {soirees} soirée mesurée | {pda} en moyenne sur {soirees} soirée mesurée | {pda} en moyenne sur {soirees} soirées mesurées',
    moisDAvant: 'Le mois d’avant',
    moisDApres: 'Le mois d’après',
    aucuneSoiree: 'Aucune soirée relevée ce mois-ci.',
    aucuneSortie: 'Aucune sortie relevée pour ce mois.',
    relevees: 'Relevées :',
    laSource: 'La source',
    tendancesChaqueMatin: 'Ce qui trend se relève chaque matin.',
    sujetsDuJour: 'Les sujets du jour',
    releve: {
      tiktok: 'Les hashtags en tendance, sur sept jours',
      x: 'Les tendances de la journée',
      fils: 'Les fils les plus suivis du jour',
    },
    vues: '{v} vues',
    messages: '{v} messages',
    publications: '{v} publications',
    heuresSur24: '{h} h sur 24',
    septDerniersJours: 'sur les sept derniers jours, jusqu’au {jour}',
    classementSeForme: 'Le classement se forme : il se relève chaque matin.',
    nouveau: 'Nouveau',
    joursSur7: '{n} jour sur 7 | {n} jour sur 7 | {n} jours sur 7',
    abonnes: '{v} abonnés',
    progression: '{v} en {jours} j',
    voirLesPremiers: 'Voir les {nb} premiers',
    personas: {
      titre: 'Les personas de son public',
      origine: 'le public de {nom}',
      q1: 'Qu’est-ce que tu viens chercher ici ?',
      q2: 'Quel programme t’a manqué cette année ?',
      q3: 'Qu’est-ce qui te ferait partir ailleurs ?',
    },
    pasDePublics: 'Pas encore de publics décrits pour ce diffuseur.',
    pdaMoisParMois: 'Sa part d’audience, mois par mois (Médiamat, {cible})',
    horsMediamat: 'Les plateformes ne sont pas au Médiamat.',
    pasAssezDeMois: 'Pas encore assez de mois publiés.',
    top10Semaine: 'Le Top 10 publié, semaine du {semaine}',
    classementAdn: 'Les séries les plus populaires sur ADN, au {jour}',
    ceQuiBouge: 'Ce qui bouge ces trois semaines',
    mouvement: {
      apparu: 'apparaît',
      monte: 'monte',
      faiblit: 'faiblit',
    },
    joursDAffilee: ', {nb} jours d’affilée',
    aucunFormat: 'Aucun format ne vise encore ce diffuseur.',
    compareA: ', comparé à {mois}',
    surLeMoisDAvant: ', sur le mois d’avant',
    classementPublie: 'Classement publié',
    horsMediamatCourt: 'hors Médiamat',
    formatsTestes: '{n} format testé | {n} format testé | {n} formats testés',
  },
  pays: {
    titre: 'Pays de l’export',
    sousTitre: 'Chaque pays lu à travers ses propres formats : ce qu’ils y ont fait, et l’envie que sa population leur donne',
    erreur: {
      liste: 'Pays illisibles',
      pays: 'Pays illisible',
      etalonnage: 'Étalonnage refusé',
    },
    laReference: 'La référence',
    lesPaysDeLExport: 'Les pays de l’export',
    sansEtalonValide: 'Sans étalon validé',
    etalonsValides: '{nb} format étalon validé sur {total} | {nb} format étalon validé sur {total} | {nb} formats étalons validés sur {total}',
    etalonneLe: 'étalonné le {moment}',
    tousLesPays: 'Tous les pays',
    releverEtalons: 'Relever les formats étalons',
    etalonnerCePays: 'Étalonner ce pays',
    dernierReleveEchoue: 'Le dernier relevé a échoué : {raison}',
    ceQueLaPopulationDonne: 'Ce que la population de {pays} donne aux formats étalons',
    droitePda: 'Un format que {envie} de ce panel voudrait regarder se lance ici autour de {valeur} de part d’audience ;',
    dixPointsPda: 'dix points d’envie de plus valent {ecart} point de part d’audience. | dix points d’envie de plus valent {ecart} point de part d’audience. | dix points d’envie de plus valent {ecart} points de part d’audience.',
    droiteTelespectateurs: 'Un format que {envie} de ce panel voudrait regarder se lance ici autour de {valeur} de téléspectateurs ;',
    dixPointsDePlus: 'dix points d’envie de plus en valent {valeur} de plus.',
    dixPointsDeMoins: 'dix points d’envie de plus en valent {valeur} de moins.',
    voirTest: 'Voir le test d’étalonnage',
    etalonsDansCePays: 'Les formats étalons dans ce pays',
    statut: {
      propose: 'à valider',
      valide: 'validé',
      rejete: 'écarté',
    },
    pasEncoreReleve: 'pas encore relevé',
    placeholderChaine: 'chaîne',
    placeholderAnnee: 'année',
    enregistrerEtValider: 'Enregistrer et valider',
    annulerMin: 'annuler',
    saisons: '{n} saison | {n} saison | {n} saisons',
    jamaisDiffuse: 'Jamais diffusé dans ce pays.',
    corriger: 'Corriger',
    lesEtalonnages: 'Les étalonnages',
    nFormats: '{nb} formats',
    nEtalonsValides: '{n} étalon validé | {n} étalon validé | {n} étalons validés',
    etalonneLeMaj: 'Étalonné le {moment}',
    aEtalonner: 'À étalonner',
    masquerSansEtalon: 'Masquer les pays sans étalon',
    voirSansEtalon: 'Voir les {nb} pays sans étalon',
  },
  weekly: {
    titre: 'Le brief',
    sousTitre: 'Les publics qui s’ouvrent, les créateurs qui montent, les genres qui saturent',
    type: {
      espace_blanc: 'Espace blanc',
      opportunite: 'Opportunité',
      emergence: 'Émergence',
      extension: 'Extension',
    },
    erreur: {
      brief: 'Brief illisible',
      lecture: 'Lecture refusée',
    },
    terrain: 'Ce que le terrain dit cette semaine',
    luLe: 'Lu le {moment}',
    lectureEnCours: 'Lecture en cours',
    relire: 'Relire maintenant',
    lire: 'Lire la semaine',
    echec: 'La lecture a échoué.',
    laSemaineSeLit: 'La semaine se lit.',
    pourquoiMaintenant: 'Pourquoi maintenant :',
    aTrancher: 'À trancher : « {question} »',
    enFaireUnFormat: 'En faire un format',
    pasEncore: 'Pas encore de brief.',
  },
  programme90: {
    titre: 'Programme 90 jours',
    sousTitre: '{nom} · J0 → J+90',
    dashboard: 'Dashboard',
    jour: 'J{n}',
    auditInitial: 'Audit initial',
    baseline: 'baseline 4R',
    aucuneCampagne: 'aucune campagne lancée',
    reAudit: 'Re-audit',
    scoreImplantationMin: "score d'implantation",
    reconstruction: 'Reconstruction du programme (audits + campagnes)…',
    demarre: "Le programme démarre au premier audit - lancez-en un depuis l'écran Audits.",
    evolution: 'Évolution 4R - mesuré à date',
    chargementHistorique: "Chargement de l'historique…",
    deuxAnalyses: 'Au moins 2 analyses sont nécessaires pour tracer une trajectoire.',
    historiqueSeRemplit: "L'historique se remplit à chaque « Lancer l'analyse complète ».",
    scoreImplantation: "Score d'implantation",
    mesureAuReAudit: 'mesuré au re-audit J+90',
    reAuditDu: 're-audit du {date}',
    definition: '= score de marque recalculé sur le nouveau cluster après implantation.',
    scoreActuel: 'Score de marque actuel',
    analysesHistorisees: 'Analyses historisées',
  },
}
